import * as React from 'react';

function SvgTrackComplete() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 1.58337C9.34167 1.58337 9.18333 1.66254 9.025 1.74171L2.77083 5.22504C2.53333 5.38337 2.375 5.62087 2.375 5.93754V13.0625C2.375 13.3792 2.53333 13.6167 2.77083 13.775L9.025 17.2584C9.18333 17.3375 9.34167 17.4167 9.5 17.4167C9.65833 17.4167 9.81667 17.3375 9.975 17.2584L10.6875 16.8625C10.45 16.3875 10.3708 15.8334 10.2917 15.2792V9.97504L15.0417 7.28337V10.2917C15.5958 10.2917 16.15 10.3709 16.625 10.5292V5.93754C16.625 5.62087 16.4667 5.38337 16.2292 5.22504L9.975 1.74171C9.81667 1.66254 9.65833 1.58337 9.5 1.58337ZM9.5 3.32504L14.25 5.93754L12.6667 6.80837L7.99583 4.11671L9.5 3.32504ZM6.4125 4.98754L11.0833 7.75837L9.5 8.62921L4.75 5.93754L6.4125 4.98754ZM3.95833 7.28337L8.70833 9.97504V15.2792L3.95833 12.5875V7.28337ZM16.8625 12.5084L14.0125 15.3584L12.7458 14.0917L11.875 15.0417L14.0917 17.4167L17.8917 13.6167L16.8625 12.5084Z"
        fill="black" />
    </svg>

  );
}

export default SvgTrackComplete;
